import { useEffect, useState } from 'react';
import { FormControl, TextField, MenuItem } from '@material-ui/core';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

const REPOSITORY_TYPES = [
  { id: 'live', name: 'Live' },
  { id: 'apod', name: 'APOD' },
  { id: 'ats', name: 'ATS' },
  { id: 'docker', name: 'Docker' },
];

const CLOUD_PROVIDERS = [
  { id: 'aws', name: 'AWS' },
  { id: 'azure', name: 'Azure' },
  { id: 'gcp', name: 'GCP' },
  { id: 'cross', name: 'Cross' },
];

export const RepositoryTypeCloudField = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<any>) => {
  const [repositoryType, setRepositoryType] = useState<string>('');
  const [cloudProvider, setCloudProvider] = useState<string>('');

  // Sync with formData
  useEffect(() => {
    if (!formData) return;

    setRepositoryType(formData.repositoryType || '');
    setCloudProvider(formData.cloudProvider || '');
  }, [formData]);

  const handleRepositoryTypeChange = (value: string) => {
    setRepositoryType(value);

    const requiresCloud = value === 'live' || value === 'apod';

    const updated: any = {
      repositoryType: value,
    };

    if (!requiresCloud) {
      setCloudProvider('');
      updated.cloudProvider = undefined;
    } else if (cloudProvider) {
      updated.cloudProvider = cloudProvider;
    }

    onChange(updated);
  };

  const handleCloudProviderChange = (value: string) => {
    setCloudProvider(value);

    onChange({
      repositoryType,
      cloudProvider: value,
    });
  };

  return (
    <FormControl margin="normal" required={required} fullWidth>
      {/* Repository Type */}
      <TextField
        select
        label="Repository Type"
        value={repositoryType}
        onChange={e => handleRepositoryTypeChange(e.target.value)}
        required
        helperText={rawErrors?.[0] || 'Select the repository type'}
        fullWidth
      >
        {REPOSITORY_TYPES.map(type => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </TextField>

      {/* Cloud Provider (conditional) */}
      {(repositoryType === 'live' || repositoryType === 'apod') && (
        <TextField
          select
          label="Cloud Provider"
          value={cloudProvider}
          onChange={e => handleCloudProviderChange(e.target.value)}
          required
          margin="normal"
          helperText={rawErrors?.[0] || 'Select the cloud provider'}
          fullWidth
        >
          {CLOUD_PROVIDERS.map(provider => (
            <MenuItem key={provider.id} value={provider.id}>
              {provider.name}
            </MenuItem>
          ))}
        </TextField>
      )}
    </FormControl>
  );
};

// -----------------------------------------------------------------------------------
// ✔️ Validación
// -----------------------------------------------------------------------------------
export const repositoryTypeCloudValidation = (
  value: { repositoryType?: string; cloudProvider?: string },
  validation: FieldValidation,
) => {
  if (!value?.repositoryType) {
    validation.addError('Repository Type is required.');
  }

  if (
    (value?.repositoryType === 'live' || value?.repositoryType === 'apod') &&
    !value?.cloudProvider
  ) {
    validation.addError('Cloud Provider is required for Live or APOD repositories.');
  }
};

// -----------------------------------------------------------------------------------
// ✔️ Registro del Custom Field
// -----------------------------------------------------------------------------------
export const RepositoryTypeCloudFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RepositoryTypeCloudField',
    component: RepositoryTypeCloudField,
    validation: repositoryTypeCloudValidation,
  }),
);
